// import React, { useMemo } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Grid,
//   TextField,
//   MenuItem,
//   FormControlLabel,
//   Switch,
//   Card,
//   CardContent,
//   Stack,
//   Typography,
//   Paper,
//   IconButton,
//   Chip,
// } from "@mui/material";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

// import EmailPreview from "./EmailPreview";
// import {
//   TEMPLATE_TYPES,
//   TEMPLATE_STATUS,
//   buildBodyHtmlFromBlocks,
//   extractVariablesFromTemplate,
// } from "../ClientEmailManager";

// const BLOCK_TYPES = [
//   { value: "header", label: "Header" },
//   { value: "text", label: "Text" },
//   { value: "image", label: "Image" },
//   { value: "button", label: "Button" },
//   { value: "footer", label: "Footer" },
//   { value: "unsubscribe", label: "Unsubscribe" },
// ];

// const EmailTemplateDialog = ({
//   open,
//   onClose,
//   templateForm,
//   setTemplateForm,
//   clientId,
//   onSave,
// }) => {
//   const previewVariableMap = useMemo(() => {
//     const vars = extractVariablesFromTemplate(templateForm);
//     return vars.reduce((acc, key) => {
//       acc[key] = key.toUpperCase();
//       return acc;
//     }, {});
//   }, [templateForm]);

//   const handleField = (field, value) => {
//     const next = { ...templateForm, [field]: value };
//     if (field === "is_global" && !value) next.client_id = clientId || "";
//     if (field === "is_global" && value) next.client_id = "";
//     setTemplateForm(next);
//   };

//   const handleBlockChange = (index, field, value) => {
//     const blocks = [...(templateForm?.body_json?.blocks || [])];
//     blocks[index] = { ...blocks[index], [field]: value };

//     const body_html = buildBodyHtmlFromBlocks(blocks);
//     const next = {
//       ...templateForm,
//       body_json: { blocks },
//       body_html,
//     };
//     next.variables = extractVariablesFromTemplate(next);
//     setTemplateForm(next);
//   };

//   const addBlock = () => {
//     const blocks = [...(templateForm?.body_json?.blocks || [])];
//     blocks.push({ type: "text", content: "" });

//     const body_html = buildBodyHtmlFromBlocks(blocks);
//     const next = {
//       ...templateForm,
//       body_json: { blocks },
//       body_html,
//     };
//     next.variables = extractVariablesFromTemplate(next);
//     setTemplateForm(next);
//   };

//   const removeBlock = (index) => {
//     const blocks = [...(templateForm?.body_json?.blocks || [])];
//     blocks.splice(index, 1);

//     const body_html = buildBodyHtmlFromBlocks(blocks);
//     const next = {
//       ...templateForm,
//       body_json: { blocks },
//       body_html,
//     };
//     next.variables = extractVariablesFromTemplate(next);
//     setTemplateForm(next);
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
//       <DialogTitle>
//         {templateForm.id ? "Edit Email Template" : "Create Email Template"}
//       </DialogTitle>

//       <DialogContent dividers>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={7}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Template Name"
//                   value={templateForm.name}
//                   onChange={(e) => handleField("name", e.target.value)}
//                 />
//               </Grid>

//               <Grid item xs={12} md={3}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Template Type"
//                   value={templateForm.template_type}
//                   onChange={(e) => handleField("template_type", e.target.value)}
//                 >
//                   {TEMPLATE_TYPES.map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               <Grid item xs={12} md={3}>
//                 <TextField
//                   select
//                   fullWidth
//                   label="Status"
//                   value={templateForm.status}
//                   onChange={(e) => handleField("status", e.target.value)}
//                 >
//                   {TEMPLATE_STATUS.map((status) => (
//                     <MenuItem key={status} value={status}>
//                       {status}
//                     </MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Subject"
//                   value={templateForm.subject}
//                   onChange={(e) => handleField("subject", e.target.value)}
//                   helperText="Supports variables like {{name}}"
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Preview Text"
//                   value={templateForm.preview_text}
//                   onChange={(e) => handleField("preview_text", e.target.value)}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <FormControlLabel
//                   control={
//                     <Switch
//                       checked={templateForm.is_global}
//                       onChange={(e) => handleField("is_global", e.target.checked)}
//                     />
//                   }
//                   label="Global Template"
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   label="Client ID"
//                   value={templateForm.client_id}
//                   disabled={templateForm.is_global}
//                   onChange={(e) => handleField("client_id", e.target.value)}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   label="Thumbnail URL"
//                   value={templateForm.thumbnail_url}
//                   onChange={(e) => handleField("thumbnail_url", e.target.value)}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ borderRadius: 3 }}>
//                   <CardContent>
//                     <Stack
//                       direction="row"
//                       justifyContent="space-between"
//                       alignItems="center"
//                       sx={{ mb: 2 }}
//                     >
//                       <Typography variant="subtitle1" fontWeight={700}>
//                         Email Blocks
//                       </Typography>
//                       <Button startIcon={<AddCircleOutlineIcon />} onClick={addBlock}>
//                         Add Block
//                       </Button>
//                     </Stack>

//                     <Stack spacing={2}>
//                       {(templateForm?.body_json?.blocks || []).map((block, index) => (
//                         <Paper key={index} variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
//                           <Grid container spacing={2}>
//                             <Grid item xs={12} md={3}>
//                               <TextField
//                                 select
//                                 fullWidth
//                                 label="Block Type"
//                                 value={block.type}
//                                 onChange={(e) =>
//                                   handleBlockChange(index, "type", e.target.value)
//                                 }
//                               >
//                                 {BLOCK_TYPES.map((item) => (
//                                   <MenuItem key={item.value} value={item.value}>
//                                     {item.label}
//                                   </MenuItem>
//                                 ))}
//                               </TextField>
//                             </Grid>

//                             {(block.type === "header" ||
//                               block.type === "text" ||
//                               block.type === "footer") && (
//                               <Grid item xs={12} md={8}>
//                                 <TextField
//                                   fullWidth
//                                   multiline
//                                   minRows={2}
//                                   label="Content"
//                                   value={block.content || ""}
//                                   onChange={(e) =>
//                                     handleBlockChange(index, "content", e.target.value)
//                                   }
//                                 />
//                               </Grid>
//                             )}

//                             {block.type === "unsubscribe" && (
//                               <Grid item xs={12} md={8}>
//                                 <TextField
//                                   fullWidth
//                                   label="Text"
//                                   value={block.text || ""}
//                                   onChange={(e) =>
//                                     handleBlockChange(index, "text", e.target.value)
//                                   }
//                                 />
//                               </Grid>
//                             )}

//                             {block.type === "image" && (
//                               <>
//                                 <Grid item xs={12} md={4}>
//                                   <TextField
//                                     fullWidth
//                                     label="Image URL"
//                                     value={block.url || ""}
//                                     onChange={(e) =>
//                                       handleBlockChange(index, "url", e.target.value)
//                                     }
//                                   />
//                                 </Grid>
//                                 <Grid item xs={12} md={4}>
//                                   <TextField
//                                     fullWidth
//                                     label="Alt Text"
//                                     value={block.alt || ""}
//                                     onChange={(e) =>
//                                       handleBlockChange(index, "alt", e.target.value)
//                                     }
//                                   />
//                                 </Grid>
//                               </>
//                             )}

//                             {block.type === "button" && (
//                               <>
//                                 <Grid item xs={12} md={4}>
//                                   <TextField
//                                     fullWidth
//                                     label="Button Label"
//                                     value={block.label || ""}
//                                     onChange={(e) =>
//                                       handleBlockChange(index, "label", e.target.value)
//                                     }
//                                   />
//                                 </Grid>
//                                 <Grid item xs={12} md={4}>
//                                   <TextField
//                                     fullWidth
//                                     label="Button URL"
//                                     value={block.url || ""}
//                                     onChange={(e) =>
//                                       handleBlockChange(index, "url", e.target.value)
//                                     }
//                                   />
//                                 </Grid>
//                               </>
//                             )}

//                             <Grid item xs={12} md={1}>
//                               <IconButton color="error" onClick={() => removeBlock(index)}>
//                                 <DeleteOutlineIcon />
//                               </IconButton>
//                             </Grid>
//                           </Grid>
//                         </Paper>
//                       ))}
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               <Grid item xs={12}>
//                 <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                   Detected Variables
//                 </Typography>
//                 <Stack direction="row" spacing={1} flexWrap="wrap">
//                   {extractVariablesFromTemplate(templateForm).length ? (
//                     extractVariablesFromTemplate(templateForm).map((v) => (
//                       <Chip key={v} label={`{{${v}}}`} size="small" />
//                     ))
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       No variables found
//                     </Typography>
//                   )}
//                 </Stack>
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12} md={5}>
//             <EmailPreview form={templateForm} variableMap={previewVariableMap} />
//           </Grid>
//         </Grid>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={onSave}>
//           Save Template
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EmailTemplateDialog;


import React, { useMemo } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, TextField,
  MenuItem, FormControlLabel, Switch, Card, CardContent, Stack, Typography,
  Paper, IconButton, Chip, Box
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";

import EmailPreview from "./EmailPreview";
import { TEMPLATE_TYPES, TEMPLATE_STATUS, buildBodyHtmlFromBlocks, extractVariablesFromTemplate } from "../ClientEmailManager";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", backgroundColor: "#f8f9fb",
    "&:hover": { backgroundColor: "#f0f2f5" },
    "&.Mui-focused": { backgroundColor: "#fff", "& .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 } }
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent }
};

const BLOCK_TYPES = [
  { value: "header", label: "Header" }, { value: "text", label: "Text" },
  { value: "image", label: "Image" }, { value: "button", label: "Button" },
  { value: "footer", label: "Footer" }, { value: "unsubscribe", label: "Unsubscribe" },
];

const EmailTemplateDialog = ({ open, onClose, templateForm, setTemplateForm, clientId, onSave }) => {
  const previewVariableMap = useMemo(() => {
    const vars = extractVariablesFromTemplate(templateForm);
    return vars.reduce((acc, key) => ({ ...acc, [key]: key.toUpperCase() }), {});
  }, [templateForm]);

  const handleField = (field, value) => {
    const next = { ...templateForm, [field]: value };
    if (field === "is_global" && !value) next.client_id = clientId || "";
    if (field === "is_global" && value) next.client_id = "";
    setTemplateForm(next);
  };

  const handleBlockChange = (index, field, value) => {
    const blocks = [...(templateForm?.body_json?.blocks || [])];
    blocks[index] = { ...blocks[index], [field]: value };
    const body_html = buildBodyHtmlFromBlocks(blocks);
    const next = { ...templateForm, body_json: { blocks }, body_html };
    next.variables = extractVariablesFromTemplate(next);
    setTemplateForm(next);
  };

  const addBlock = () => {
    const blocks = [...(templateForm?.body_json?.blocks || []), { type: "text", content: "" }];
    const body_html = buildBodyHtmlFromBlocks(blocks);
    const next = { ...templateForm, body_json: { blocks }, body_html };
    next.variables = extractVariablesFromTemplate(next);
    setTemplateForm(next);
  };

  const removeBlock = (index) => {
    const blocks = [...(templateForm?.body_json?.blocks || [])];
    blocks.splice(index, 1);
    const body_html = buildBodyHtmlFromBlocks(blocks);
    const next = { ...templateForm, body_json: { blocks }, body_html };
    next.variables = extractVariablesFromTemplate(next);
    setTemplateForm(next);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, color: "#fff", fontWeight: 700, fontSize: 20 }}>
        {templateForm.id ? "Edit Email Template" : "Create Email Template"}
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <Grid container spacing={3}>
          {/* Editor */}
          <Grid item xs={12} md={7}>
            <Stack spacing={2.5}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}><TextField fullWidth label="Template Name" value={templateForm.name} onChange={(e) => handleField("name", e.target.value)} sx={inputSx} /></Grid>
                <Grid item xs={6} md={3}><TextField select fullWidth label="Type" value={templateForm.template_type} onChange={(e) => handleField("template_type", e.target.value)} sx={inputSx}>{TEMPLATE_TYPES.map((t) => <MenuItem key={t} value={t}>{t}</MenuItem>)}</TextField></Grid>
                <Grid item xs={6} md={3}><TextField select fullWidth label="Status" value={templateForm.status} onChange={(e) => handleField("status", e.target.value)} sx={inputSx}>{TEMPLATE_STATUS.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}</TextField></Grid>
              </Grid>

              <TextField fullWidth label="Subject" value={templateForm.subject} onChange={(e) => handleField("subject", e.target.value)} helperText="Use {{variable}} syntax" sx={inputSx} />
              <TextField fullWidth label="Preview Text" value={templateForm.preview_text} onChange={(e) => handleField("preview_text", e.target.value)} sx={inputSx} />

              <Grid container spacing={2}>
                <Grid item xs={4}><FormControlLabel control={<Switch checked={templateForm.is_global} onChange={(e) => handleField("is_global", e.target.checked)} sx={{ "& .Mui-checked": { color: accent } }} />} label="Global" /></Grid>
                <Grid item xs={4}><TextField fullWidth size="small" label="Client ID" value={templateForm.client_id} disabled={templateForm.is_global} onChange={(e) => handleField("client_id", e.target.value)} sx={inputSx} /></Grid>
                <Grid item xs={4}><TextField fullWidth size="small" label="Thumbnail URL" value={templateForm.thumbnail_url} onChange={(e) => handleField("thumbnail_url", e.target.value)} sx={inputSx} /></Grid>
              </Grid>

              {/* Blocks */}
              <Paper elevation={0} sx={{ borderRadius: 3, border: "1px solid #e3e8f0", overflow: "hidden" }}>
                <Box sx={{ px: 2.5, py: 2, backgroundColor: accentLight, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ color: accent }}>Email Blocks</Typography>
                  <Button size="small" startIcon={<AddCircleOutlineIcon />} onClick={addBlock} sx={{ color: accent, fontWeight: 600 }}>Add Block</Button>
                </Box>
                <Stack spacing={1.5} sx={{ p: 2.5 }}>
                  {(templateForm?.body_json?.blocks || []).map((block, index) => (
                    <Paper key={index} elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid #e3e8f0", "&:hover": { borderColor: accent } }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={3}>
                          <TextField select fullWidth size="small" label="Block Type" value={block.type} onChange={(e) => handleBlockChange(index, "type", e.target.value)} sx={inputSx}>
                            {BLOCK_TYPES.map((item) => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
                          </TextField>
                        </Grid>
                        {["header", "text", "footer"].includes(block.type) && (
                          <Grid item xs={12} md={8}><TextField fullWidth size="small" multiline minRows={2} label="Content" value={block.content || ""} onChange={(e) => handleBlockChange(index, "content", e.target.value)} sx={inputSx} /></Grid>
                        )}
                        {block.type === "unsubscribe" && (
                          <Grid item xs={12} md={8}><TextField fullWidth size="small" label="Text" value={block.text || ""} onChange={(e) => handleBlockChange(index, "text", e.target.value)} sx={inputSx} /></Grid>
                        )}
                        {block.type === "image" && (<>
                          <Grid item xs={6} md={4}><TextField fullWidth size="small" label="Image URL" value={block.url || ""} onChange={(e) => handleBlockChange(index, "url", e.target.value)} sx={inputSx} /></Grid>
                          <Grid item xs={6} md={4}><TextField fullWidth size="small" label="Alt Text" value={block.alt || ""} onChange={(e) => handleBlockChange(index, "alt", e.target.value)} sx={inputSx} /></Grid>
                        </>)}
                        {block.type === "button" && (<>
                          <Grid item xs={6} md={4}><TextField fullWidth size="small" label="Label" value={block.label || ""} onChange={(e) => handleBlockChange(index, "label", e.target.value)} sx={inputSx} /></Grid>
                          <Grid item xs={6} md={4}><TextField fullWidth size="small" label="URL" value={block.url || ""} onChange={(e) => handleBlockChange(index, "url", e.target.value)} sx={inputSx} /></Grid>
                        </>)}
                        <Grid item xs={12} md={1}><IconButton size="small" onClick={() => removeBlock(index)} sx={{ color: "#ef5350" }}><DeleteOutlineIcon /></IconButton></Grid>
                      </Grid>
                    </Paper>
                  ))}
                </Stack>
              </Paper>

              {/* Variables */}
              <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
                <CodeOutlinedIcon sx={{ color: accent, fontSize: 18 }} />
                <Typography variant="subtitle2" fontWeight={600}>Detected Variables:</Typography>
                {extractVariablesFromTemplate(templateForm).length ? extractVariablesFromTemplate(templateForm).map((v) => (
                  <Chip key={v} label={`{{${v}}}`} size="small" sx={{ backgroundColor: accentLight, color: accent, fontWeight: 600 }} />
                )) : <Typography variant="body2" color="text.secondary">None</Typography>}
              </Stack>
            </Stack>
          </Grid>

          {/* Preview */}
          <Grid item xs={12} md={5}>
            <EmailPreview form={templateForm} variableMap={previewVariableMap} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} sx={{ color: "#666" }}>Cancel</Button>
        <Button variant="contained" startIcon={<SaveOutlinedIcon />} onClick={onSave}
          sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, borderRadius: 2, px: 3, fontWeight: 600 }}>Save Template</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailTemplateDialog;
